export default __webpack_public_path__ + "static/media/plugin.4155c5b7.svg";